import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0579c4ea&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0579c4ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0579c4ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0579c4ea')) {
      api.createRecord('0579c4ea', component.options)
    } else {
      api.reload('0579c4ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0579c4ea&scoped=true&", function () {
      api.rerender('0579c4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwDefaultAvatar/index.vue"
export default component.exports